



























import Vue from 'vue'

import IconTaskFolder from '@/components/icons/icon-task-folder.vue'

// import NavViewLink from './nav-view-link.vue'
// import NavViewGroup from './nav-view-group.vue'

export default Vue.extend({
  name: 'NavTag',
  components: {
    IconTaskFolder,
  },
  data() {
    return {
      // eslint-disable-next-line
      expand: false,
    }
  },
  methods: {},
})
